(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowupTypeDeleteController',FollowupTypeDeleteController);

    FollowupTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'FollowupType'];

    function FollowupTypeDeleteController($uibModalInstance, entity, FollowupType) {
        var vm = this;
        vm.followupType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            FollowupType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
